import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const AccountProviderUserUpdatePage = lazy(() => import('../views/update/AccountProviderUserUpdatePage'));

export function AccountProviderUserUpdatePageLazy() {
	return (
		<PageSuspense>
			<AccountProviderUserUpdatePage />
		</PageSuspense>
	);
}
